<template lang="pug">
  base-node(:data="data" :nodeType="IQ_TOOL_ACTION_TYPE_DIALOG")
    template(#icon)
      i.iq-ico-building-kit-dialog
</template>

<script>
import BaseNode from './BaseNode.vue';
import { IQ_TOOL_ACTION_TYPE_DIALOG } from '@/constants/iqtool';

export default {
  name: 'DiagramDialogNode',
  components: {
    BaseNode,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      IQ_TOOL_ACTION_TYPE_DIALOG,
    };
  },
};
</script>

<style scoped>
  .dialog-node-wrapper {
    border-color: #CC5C94;
  }
  .iq-ico-building-kit-dialog::before {
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 19 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1.875C0 0.84082 0.852031 0 1.9 0H10.45C11.498 0 12.35 0.84082 12.35 1.875V7.5C12.35 8.53418 11.498 9.375 10.45 9.375H6.01766L3.61 11.1562C3.4675 11.2617 3.27453 11.2793 3.11125 11.2002C2.94797 11.1211 2.85 10.96 2.85 10.7812V9.375H1.9C0.852031 9.375 0 8.53418 0 7.5V1.875ZM7.6 10.3125H10.45C12.0234 10.3125 13.3 9.05273 13.3 7.5V3.75H17.1C18.148 3.75 19 4.59082 19 5.625V11.25C19 12.2842 18.148 13.125 17.1 13.125H16.15V14.5312C16.15 14.71 16.0491 14.8711 15.8888 14.9502C15.7284 15.0293 15.5355 15.0117 15.39 14.9062L12.9823 13.125H9.5C8.45203 13.125 7.6 12.2842 7.6 11.25V10.3125ZM4.04344 2.70703L4.03156 2.73633C3.92172 3.04102 4.085 3.375 4.39375 3.4834C4.7025 3.5918 5.04094 3.43066 5.15078 3.12598L5.16266 3.09668C5.18937 3.01758 5.26656 2.96777 5.34969 2.96777H6.78953C6.99734 2.96777 7.16359 3.13477 7.16359 3.33691C7.16359 3.46875 7.09234 3.5918 6.97656 3.65625L5.87812 4.28027C5.69406 4.38574 5.58125 4.5791 5.58125 4.78711V5.11523C5.58125 5.4375 5.84844 5.70117 6.175 5.70117C6.49859 5.70117 6.76281 5.44336 6.76875 5.12695L7.56734 4.67578C8.05125 4.40039 8.35109 3.89062 8.35109 3.33984C8.35109 2.4873 7.65047 1.79883 6.78953 1.79883H5.34969C4.76187 1.79883 4.23937 2.16211 4.04344 2.70996V2.70703ZM6.96766 7.26562C6.97427 7.15907 6.95872 7.05231 6.92195 6.95191C6.88518 6.85151 6.82798 6.7596 6.75387 6.68184C6.67975 6.60408 6.59029 6.54212 6.49099 6.49976C6.39169 6.4574 6.28466 6.43555 6.17648 6.43555C6.06831 6.43555 5.96128 6.4574 5.86198 6.49976C5.76268 6.54212 5.67322 6.60408 5.5991 6.68184C5.52499 6.7596 5.46778 6.85151 5.43102 6.95191C5.39425 7.05231 5.3787 7.15907 5.38531 7.26562C5.3787 7.37218 5.39425 7.47894 5.43102 7.57934C5.46778 7.67974 5.52499 7.77165 5.5991 7.84941C5.67322 7.92717 5.76268 7.98913 5.86198 8.03149C5.96128 8.07385 6.06831 8.0957 6.17648 8.0957C6.28466 8.0957 6.39169 8.07385 6.49099 8.03149C6.59029 7.98913 6.67975 7.92717 6.75387 7.84941C6.82798 7.77165 6.88518 7.67974 6.92195 7.57934C6.95872 7.47894 6.97427 7.37218 6.96766 7.26562Z' fill='%23CC5C94'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    width: 11px;
    height: 11px;
  }
</style>